import React, { ReactElement, ReactNode, useState } from "react";
import PieceList, { PieceListProps } from "./pieceList";
import SearchBar from "../searchBar";

import "./pieceListWithSearchBar.css";


export default function PieceListSearchBar(props: PieceListProps) {

    const [search, setSearch] = useState("");

    return <div className="piece-list-with-search-bar">
        <SearchBar search={search} onSearch={setSearch}/>
        <PieceList
        children={props.children}
        pieces={props.pieces}
        displayProps={props.displayProps}
        />
    </div>;
}